import { type ReactNode, useState } from 'react';
import { api, ApiError } from '../api/client';
import { config } from '../config';
import { Flag, Logo, ThemeToggle } from './Layout';

const GATE_KEY = 'casijud.demo.acces';

function opened(): boolean {
  try {
    return window.localStorage.getItem(GATE_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Porte d'accès du site de démonstration : un mot de passe communiqué aux testeurs, vérifié par l'API, avant
 * d'afficher quoi que ce soit. Absente en mode OIDC (recette, production), où l'authentification réelle s'applique.
 */
export function AccessGate({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(() => config.authMode !== 'dev' || opened());
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (open) return <>{children}</>;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('/dev/acces', { method: 'POST', body: { motDePasse: password } });
      try {
        window.localStorage.setItem(GATE_KEY, '1');
      } catch {
        // stockage indisponible : la porte sera redemandée au prochain chargement
      }
      setOpen(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Vérification impossible. Réessayez.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="gate">
      <Flag />
      <div style={{ position: 'absolute', top: 14, right: 14 }}>
        <ThemeToggle />
      </div>
      <form className="gate-card stack" onSubmit={submit}>
        <Logo width={150} />
        <div>
          <p className="eyebrow">Accès sécurisé</p>
          <h1>Accès réservé</h1>
          <p className="muted">Saisissez le mot de passe d’accès qui vous a été communiqué.</p>
        </div>
        <div className="field">
          <label htmlFor="gate-password">Mot de passe d’accès</label>
          <input
            id="gate-password"
            type="password"
            autoComplete="off"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && (
          <p className="alert alert-danger" role="alert">
            {error}
          </p>
        )}
        <button className="btn" type="submit" disabled={busy || !password.trim()}>
          {busy ? 'Vérification…' : 'Entrer sur le site'}
        </button>
        <p className="small muted" style={{ margin: 0 }}>
          République gabonaise · Ministère de la Justice - proposition d’Infinity Digital Gabon
        </p>
      </form>
    </div>
  );
}
